import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import AOS from "aos";
import "./AboutStyle.css";
import me from "../../assets/ali.png";

const About = ({ id }) => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-out",
      once: true,
    });
  }, []);

  return (
    <section id={id} className="about-section">
      <div
        className="container about-content"
        dir={i18n.language === "ar" ? "rtl" : "ltr"}
      >
        <div
          className="about-image"
          data-aos="fade-right"
          data-aos-offset="200"
        >
          <img src={me} alt={t("about.name")} />
        </div>
        <div className="about-text" data-aos="fade-left" data-aos-offset="200">
          <h2>{t("about.title")}</h2>
          <p>{t("about.bio1")}</p>
          <p>{t("about.bio2")}</p>
          {/* <button className="more-btn">{t("about.more")}</button> */}
        </div>
      </div>
    </section>
  );
};

export default About;
